export const BacklogSource = {
  Jira: 'jira',
  Xlsx: 'xlsx',
  Structure: 'structure',
  StrategicRoadmaps: 'strategicRoadmaps',
} as const;

export type BacklogSource = (typeof BacklogSource)[keyof typeof BacklogSource];

export const PlanStatus = {
  Created: 'CREATED',
  ScenarioGenerated: 'SCENARIO_GENERATED',
  Activated: 'ACTIVATED',
} as const;

export type PlanStatus = (typeof PlanStatus)[keyof typeof PlanStatus];

export const PlanValidation = {
  MissingTeam: 'MISSING_TEAM',
  EmptyTeam: 'EMPTY_TEAM',
  NoAvailability: 'NO_AVAILABILITY',
  TeamUnavailable: 'TEAM_UNAVAILABLE',
  MissingEstimation: 'MISSING_ESTIMATION',
  ItemIsDone: 'ITEM_IS_DONE',
  AllItemsUnschedulable: 'ALL_ITEMS_UNSCHEDULABLE',
} as const;

export type PlanValidation = (typeof PlanValidation)[keyof typeof PlanValidation];

export interface Plan {
  id: number;
  organizationId: string;
  name: string;
  description: string | null;
  targetStartDate: string;
  targetFinishDate: string;
  status: PlanStatus;
  lastActivatedScenarioId: number | null;
  activatedBy: string | null;
  lastActivatedDate: string | null;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  teamRoleIds: number[] | null;
  skillIds: number[] | null;
  loopId: number;
  schedulingValidations: PlanValidation[];
}

export interface PlanCreateRequest {
  description?: string | null;
  targetStartDate: string;
  targetFinishDate: string;
  teamRoleIds?: number[] | null;
  skillIds?: number[] | null;
  loopId: number;
}

export interface PlanUpdateRequest {
  description?: string | null;
  targetStartDate?: string;
  targetFinishDate?: string;
  status?: PlanStatus;
  lastActivatedScenarioId?: number;
  lastActivatedDate?: string;
  activatedBy?: string;
  teamRoleIds?: number[] | null;
  skillIds?: number[] | null;
}

export const RadarRange = {
  High: 'HIGH',
  Medium: 'MEDIUM',
  Low: 'LOW',
} as const;

export type RadarRange = (typeof RadarRange)[keyof typeof RadarRange];
